// Pantalla `command="login-update-password"`. Port de la rama `when
// "login-update-password"` de keycloak.coffee. Dos campos password +
// confirm. Si es AIA, botón Cancelar con name="cancel-aia" para que KC
// termine la AIA y vuelva al cliente con kc_action_status=cancelled.

import type { FormEvent } from "react";
import type { KcData } from "../kcData";
import { Input } from "../components/Input";
import { StandardPage } from "../components/StandardPage";
import { msg } from "../i18n";

export interface LoginUpdatePasswordPageProps {
  data: KcData;
  running: boolean;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
}

export function LoginUpdatePasswordPage(props: LoginUpdatePasswordPageProps) {
  const { data, running, onSubmit } = props;

  return (
    <StandardPage page="login-update-password" data={data}>
      <form
        id="kc-passwd-update-form"
        action={data.url!.loginAction}
        method="post"
        onSubmit={onSubmit}
      >
        <Input
          type="password"
          id="password-new"
          name="password-new"
          autoFocus
          placeholder={msg("passwordNew")}
          messagesPerField={data.messagesPerField}
        />
        <Input
          type="password"
          id="password-confirm"
          name="password-confirm"
          placeholder={msg("passwordConfirmNew")}
          messagesPerField={data.messagesPerField}
        />
        <button
          type="submit"
          className="btn btn-lg btn-block btn-primary"
          disabled={running}
        >
          {msg("doContinue")}
        </button>
        {data.isAppInitiatedAction ? (
          // OJO: este botón NO lleva disabled={running} ni un onClick que
          // haga setState. En React 18 (a diferencia del legacy CoffeeScript
          // que mutaba data.running sin re-render), un setState en onClick
          // re-renderiza el botón como disabled ANTES de que el browser
          // serialice el form, y el par cancel-aia=true se queda fuera del
          // POST → KC procesa el submit como si fuera el botón principal.
          <button
            type="submit"
            name="cancel-aia"
            value="true"
            className="btn btn-lg btn-block btn-default"
          >
            {msg("doCancel")}
          </button>
        ) : null}
      </form>
    </StandardPage>
  );
}
